<template>
  <div class="section mb-3">
    <h4 class="section-title">
      <font-awesome-icon :icon="['fas', 'bullseye']" /> Objetivo de la Tarea
    </h4>
    <div class="row mb-2">
      <!-- Categoria del Objetivo -->
      <div class="col-md-12">
        <label class="form-label">Categoría del Objetivo</label>
        <div class="pills-container">
          <button
            v-for="tipoObjeto in categoriasTiposObjetos"
            :key="tipoObjeto.id"
            :class="['pill', { active: localTipoObjeto === tipoObjeto.tipo_objeto }]"
            @click="localTipoObjeto = tipoObjeto.tipo_objeto"
          >
            {{ tipoObjeto.tipo_objeto }}
          </button>
        </div>
      </div>
      <!-- Objeto a Seleccionar -->
      <div class="col-md-12 mt-2">
        <label for="objeto_id" class="form-label">Objeto a Seleccionar</label>
        <select
          id="objeto_id"
          class="form-select form-select-sm"
          v-model="localObjeto"
          required
        >
          <option value="">Seleccione un objeto</option>
          <option v-for="objeto in objetosFiltrados" :key="objeto.id" :value="objeto.id">
            {{ objeto.nombre }} 
            <span v-if="objeto.planta">- Lote: {{ objeto.planta.lote.nombre }}</span>

          </option>
        </select>
        <!-- Mensaje si no hay objetos disponibles y la categoría es Lote -->
        <div v-if="localTipoObjeto === 'Lote' && objetosFiltrados.length === 0" class="alert alert-warning mt-2 p-2">
          Asegúrese de que los lotes estén bloqueados para que puedan aparecer en esta lista.
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.section {
  border: 1px solid #e3e3e3;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.section-title {
  margin-bottom: 10px;
  font-size: 1.1rem;
  color: var(--app-primary);
}

.form-label {
  margin-bottom: 0.2rem;
}

.form-select-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
}

.alert {
  font-size: 0.85rem;
  background-color: #fff3cd;
  border-color: #ffeeba;
  color: #856404;
}

.pills-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.pill {
  padding: 0.5rem 1rem;
  border: 1px solid var(--app-primary);
  border-radius: 20px;
  background-color: white;
  color: var(--app-primary);
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.pill.active {
  background-color: var(--app-primary);
  color: white;
}

.pill:hover {
  background-color: var(--app-primary-light);
  color: white;
}
</style>

<script>
import axios from '@/axios';

export default {
  props: {
    selectedTipoObjeto: {
      type: String,
      default: '',
    },
    selectedObjeto: {
      type: [Number, String, null],
      default: null,
    },
    esEdicion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localTipoObjeto: this.selectedTipoObjeto || '',
      localObjeto: this.selectedObjeto || '',
      categoriasTiposObjetos: [],
      objetosFiltrados: [],
      clubActual: this.$store.getters.getClubActual,
    };
  },
  created() {
    this.obtenerTiposDeObjetos();

    if (this.esEdicion && this.localTipoObjeto) {
      this.obtenerObjetosPorTipo();
    }
  },
  methods: {
    async obtenerTiposDeObjetos() {
      try {
        const response = await axios.get('/api/objetoDistinctTipos', {
          params: {
            club_id: this.clubActual.id,
          },
        });
        this.categoriasTiposObjetos = response.data;
      } catch (error) {
        console.error('Error al cargar los tipos de objetos:', error);
      }
    },

    async obtenerObjetosPorTipo() {
      if (this.localTipoObjeto) {
        try {
          const proyecto_id = this.$store.getters.getProyectoActual.id;
          const response = await axios.get(`/api/objetoPorTipo/${this.localTipoObjeto}/${proyecto_id}`, {
            params: {
              club_id: this.clubActual.id,
            },
          });
          this.objetosFiltrados = response.data;
        } catch (error) {
          console.error('Error al obtener objetos por tipo:', error);
        }
      }
    },

    enviarDatos() {
      this.$emit('actualizar-objetivo', {
        tipo_objeto: this.localTipoObjeto,
        objeto_id: this.localObjeto,
      });
    },
  },
  watch: {
    localTipoObjeto() {
      this.obtenerObjetosPorTipo();
      this.enviarDatos();
    },
    localObjeto() {
      this.enviarDatos();
    },
  },
};
</script>
